<style src="css/correct.css" scoped></style>
<template>
    <div style="padding-top: 1rem;min-height: 100vh;background: #fff">
        <newsTopBox title="心理评测"></newsTopBox>
        <div class="banner" @click="startCallHelp"></div>
        <div class="serviceNotice" v-if="learnTask">
            <div class="sNWord">服务通知</div>
            <div class="sNLine"></div>
            <div class="sNContent">{{learnTask}}</div>
        </div>
        <ul class="contentBox">
            <li class="contentItem" v-for="item in scaleGroupList" @click="toWhere(item.enable,item.groupId)">
                <img :src="EnvUrl+item.pic" alt="" class="itemIcon">
                <div class="itemRight">
                    <div class="itemTitle">{{item.title}}</div>
                    <div class="itemTagline">{{item.tagline}}</div>
                </div>
                <div class="lock" v-if="!item.enable"></div>
            </li>
            <li class="contentItem special" @click="to('')">
                <div class="itemIcon"></div>
                <div class="itemRight">
                    <div class="itemTitle">心理服务</div>
                    <div class="itemTagline">提供心理咨询、课程内容等相关服务</div>
                </div>
            </li>
            <li class="contentItem special"  @click="toHelp(2)">
                <div class="itemIcon iI5"></div>
                <div class="itemRight">
                    <div class="itemTitle">婚姻家庭</div>
                    <div class="itemTagline">夫妻、家庭矛盾寻求帮助</div>
                </div>
            </li>
            <li class="contentItem special"  @click="toHelp(1)">
                <div class="itemIcon iI6"></div>
                <div class="itemRight">
                    <div class="itemTitle">法律援助</div>
                    <div class="itemTagline">法律纠纷、咨询援助</div>
                </div>
            </li>
            <li class="contentItem special"   @click="toHelp(0)">
                <div class="itemIcon iI8"></div>
                <div class="itemRight">
                    <div class="itemTitle">困难帮扶</div>
                    <div class="itemTagline">家庭、生活有困难我们一起努力渡难关</div>
                </div>
            </li>
            <li class="contentItem special">
                <div class="itemIcon iI7"></div>
                <div class="itemRight">
                    <div class="itemTitle">技能培训</div>
                    <div class="itemTagline">就业指导技能培训</div>
                </div>
            </li>
        </ul>

    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import newsTopBox from 'components/newsTopBox'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {Swiper, Slide} from 'vue-swiper-component';
    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                scaleGroupList:[],
                learnTask:''
            }
        },
        components: {
            noMoreData,
            topbar,
            Swiper,
            Slide,
            newsTopBox
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {
            async startCallHelp() {
                let data = await getSources("/bear-scale/api/callrecord/startCallHelp", {userId:localStorage.getItem('userId')});
                if (data.status === 0) {
                   if(data.bespeakSwitchPhone){
                        // this.cancle();
                        setTimeout(()=>{
                            this.showTip(`请注意接听来电~`)
                        },200)

                    }else{
                        window.location.href = 'tel://' + data.middleNumber
                    }
                }else{
                    alert(data.msg)
                }
            },
            // gotel(){
            //     window.location.href = 'tel://' + '13961160035'
            // },
            toWhere(enable,groupId){
                if(enable){
                    this.to(`mentalExperience?groupId=${groupId}`)
                }
            },
            toHelp(e){
               this.$router.push(`/help?type=${e}`);
            },
            to(n) {
                this.$router.push(`/${n}`)
            },
            async getScaleGroupComboList() {
                let data = await getSources("/bear-scale/api/scaleGroup/getScaleGroupComboList.json", {userId:localStorage.getItem('userId')});
                if (data.status === 0) {
                    this.scaleGroupList = data.scaleGroupList
                    this.learnTask = data.learnTask
                }else{
                    alert(data.msg)
                }
            },

        },
        destroyed(){
        },
        mounted() {
            this.getScaleGroupComboList()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/correct.vue?00d6839b